 
import { gql, useQuery } from '@apollo/client';
import AnalyticsSidebar from 'components/common/analytics-sidebar';
import styled from 'styled-components';
import StoryLevelWrapper from '../components/content-value/story-level/index';
import Header from '../components/common/Header';
import { BrandProfile } from 'types';

const StoryLevelContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  max-width: 1920px;
  padding: 0 20px;
  margin: 0 auto;
  clear: both;
`;

const StoryLevelRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  @media screen and (max-width: 1000px) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column;
    flex-flow: column;
  }
`;

const StoryLevelColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 4;
`;

const AnalyticsSidebarColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 0%;
  flex: 1;
`;

export const STORY_LEVEL_QUERY = gql`
  query StoryLevel($pubId: ID!) {
    brandProfile(pubId: $pubId) {
      contentValueSnapshot {
        avgTrafficValueBySinglePub {
          avgUsTraffic
          avgCanadaTraffic
          avgAllTraffic
        }
        storyLevelStats {
          id
          title
          creator
          publishedToUrl
          contentPillar
          allTraffic
          allTrafficValue
          usTraffic
          usTrafficValue
          canadaTraffic
          canadaTrafficValue
          contentSpend
        }
      }
    }
  }
`;

const pubId = '13';
export const pubQueryVars = { pubId };

interface StoryLevelVars {
  pubId: string;
}

interface BrandProfileData {
  brandProfile: BrandProfile;
}

function StoryLevel() {
  const { loading, error, data } = useQuery<BrandProfileData, StoryLevelVars>(STORY_LEVEL_QUERY, {
    variables: pubQueryVars,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error!</div>;
  }

  // @ts-ignore
  // not sure why Property 'avgTrafficValue' does not exist on type 'Maybe<ContentValueBase> | undefined'.ts(2339)
  const { avgTrafficValueBySinglePub, storyLevelStats } = data?.brandProfile.contentValueSnapshot || {};

  return (avgTrafficValueBySinglePub && storyLevelStats) ? (
    <>
      <Header header={'Analytics'} />
      <StoryLevelContainer>
        <StoryLevelRow>
          <AnalyticsSidebarColumn>
            <AnalyticsSidebar />
          </AnalyticsSidebarColumn>
          <StoryLevelColumn>
            <StoryLevelWrapper
              avgTrafficValueBySinglePub={avgTrafficValueBySinglePub}
              storyLevelStats={storyLevelStats}
              pubId={pubId}
            />
          </StoryLevelColumn>
        </StoryLevelRow>
      </StoryLevelContainer>
    </>
  ) : null;
}

export default StoryLevel;
